#@import _
#@import Backbone
#@export Booking.Helpers

Booking.Helpers =

  # Returns a moment object from an ISOString or a moment object as if it were on the given timezone
  timezonedDatetime: (datetime, timezone) ->
    moment.tz(datetime, timezone)

  # Returns a timezoned moment object from a moment object, a timestamp or a ISOString
  objectInTimezone: (obj, timezone) ->
    # Moment obj
    if moment.isMoment(obj)
      moment(obj).tz(timezone)
    # Timestamp
    else if _.isFinite(obj)
      moment.unix(obj).tz(timezone)
    # String
    else
      Booking.Helpers.timezonedDatetime(obj, timezone)

  getNowInTimezone: (timezone) ->
    moment().tz(timezone)

  isDateInFuture: (dateMoment, timezone) ->
    dateMoment.unix() > Booking.Helpers.getNowInTimezone(timezone).unix()

  getNowToEndOfMonthRange: (start) ->
    end = moment(start).endOf('month')
    {start, end}

  getNowtoNextMonthRange: (start) ->
    end = moment(start).add(1, 'M').endOf('month')
    {start, end}

  getFullMonthRange: (start, timezone) ->
    now = Booking.Helpers.getNowInTimezone(timezone)
    if moment(start).isSame(now, 'months')
      start = now
      end = moment(start).endOf('month')
      {start, end}
    else
      start = moment(start).startOf('month')
      end = moment(start).endOf('month')
      {start, end}

  getDayRange: (day) ->
    start: moment(day).startOf('day')
    end: moment(day).endOf('day')

  getTimestampMonthRange: (month) ->
    {start, end} = Booking.Helpers.getNowToEndOfMonthRange(month)

    start = start.unix()
    end = end.unix()

    {start, end}

  getTimestampDayRange: (day) ->
    {start, end} = Booking.Helpers.getDayRange(day)

    start = start.unix()
    end = end.unix()

    {start, end}

  addTimezoneToMoment: (timezoneData) ->
    moment.tz.add(timezoneData) if timezoneData?

